export default "__VITE_ASSET__BvRjtS$R__"